exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".box.is-danger[data-v-a839c58c]{border:2px solid #ff3860}.image.is-256x144[data-v-a839c58c]{width:256px;height:144px}.slide-image[data-v-a839c58c]{width:256px}.slide-thumb[data-v-a839c58c]{border:1px solid #d3d3d3}.vertical-rule[data-v-a839c58c]{width:1px;align-self:stretch;background:#d3d3d3;margin-right:1rem}.vertical-center[data-v-a839c58c]{align-self:center}.content.display-mode[data-v-a839c58c]{min-height:96px}div.control small.help.counter[data-v-a839c58c]{margin-bottom:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a839c58c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/create/EditSectionSlide.vue
// module id = 147
// module chunks = 6